import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAdminIo } from '../auth/useAdmin'
import { listUserFolders } from '../upload/adminS3'
import { loadProfile } from '../upload/profile'
import './Admin.css'

type UserRow = { id: string; name?: string }

type LoadState =
  | { kind: 'loading' }
  | { kind: 'ready'; users: UserRow[] }
  | { kind: 'error'; message: string }

export default function Admin() {
  const io = useAdminIo()
  const [state, setState] = useState<LoadState>({ kind: 'loading' })

  useEffect(() => {
    if (!io) return
    let cancelled = false
    listUserFolders(io)
      .then(async (folders) => {
        folders.sort()
        const users = await Promise.all(
          folders.map(async (id): Promise<UserRow> => {
            try {
              const profile = await loadProfile(io, id)
              const name = profile?.creatorName
              return typeof name === 'string' && name ? { id, name } : { id }
            } catch (err) {
              console.warn('[admin] loadProfile failed', { id, err })
              return { id }
            }
          }),
        )
        if (cancelled) return
        setState({ kind: 'ready', users })
      })
      .catch((err: unknown) => {
        if (cancelled) return
        console.error('[admin] listUserFolders failed', err)
        const message = err instanceof Error ? err.message : 'Failed to load'
        setState({ kind: 'error', message })
      })
    return () => {
      cancelled = true
    }
  }, [io])

  return (
    <section className="admin">
      <h1 className="page-title">Admin</h1>
      <p className="page-lede">All user folders in the uploads bucket.</p>

      {state.kind === 'loading' && <p>Loading…</p>}
      {state.kind === 'error' && (
        <p className="admin__error" role="alert">
          Couldn't load folders: {state.message}
        </p>
      )}
      {state.kind === 'ready' && (
        <>
          <p className="admin__count">{state.users.length} users</p>
          <ul className="admin__list">
            {state.users.map(({ id, name }) => (
              <li key={id}>
                <Link to={`/admin/users/${encodeURIComponent(id)}`}>{id}</Link>
                {name && <span className="admin__name">{name}</span>}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  )
}
